<template>
<div v-on:click.ctrl="printNotFiscalTicket()">  
   <img  v-show="false" id="barcode"/>


  <fiscal-printer v-if="fp.show && getFiscalPrinter1(fiscalPrinterNew.fpId) " @close="fp.show=false" v-bind:notFiscal="fp.notFiscal" v-bind:giftTicket="giftTicket" @finish="closeFiscalPrint"  v-bind:saleId="saleId" v-bind:deskId="deskId"></fiscal-printer>    
  <fiscalPrinterNew v-if="fiscalPrinterNew.show && getFiscalPrinter2(fiscalPrinterNew.fpId)" v-bind:data="fiscalPrinterNew" @close="closeFiscalPrinter()"> </fiscalPrinterNew>
  <notFiscalEpsonReceipt v-if="notFiscal" v-bind:saleId="saleId" @close="notFiscal=false"></notFiscalEpsonReceipt>
  <modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
  
  <div class="card border-success">
  <div class="card-header text-white bg-primary main">
    <h4> <i style="color:#FFD700" class="fas fa-shopping-bag mr-3" aria-hidden="true"></i>ULTIMA VENDITA</h4>   
  </div>

  <div class="card-body">  
  <div class="row">
  <div class="col-sm">
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table class="table  mb-0">
    <thead class="table1">
    <tr>
        <th></th>
        <th>DATA e ORA</th>
        <th>PROVENIENZA</th>
        <th>CLIENTE</th>
        <th scope="col">TIPO</th>
        <th><i  class="fas fa-user-tag" aria-hidden="true"></i></th>
        <th scope="col">EAN</th>
        <th scope="col">PRODOTTO</th>
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
        
        <!--<th class="text-right" scope="col">Q.TA'</th>-->

        <th class="text-right" scope="col">IMPORTO</th>
        <th class="text-right" scope="col">SCONTO</th>
        <th class="text-right" scope="col">SUBTOTALE</th>
        <th class="text-right" scope="col">ABBUONO %</th>
        <th class="text-right" scope="col">ABBUONO €</th>
        <th class="text-right" scope="col"> TOTALE</th>
        <th class="text-right" scope="col">PAGAMENTO</th>
        <th></th>
        <th></th>
        
        
      </tr>
    </thead>
    <tbody>

      <tr :style="{backgroundColor: item.rowType==2 ? '#FFFFE0':'white', color: item.rowType==2  ? 'blue' : 'black',fontSize: item.rowType == 2 ? '22px':'16px',fontWeight:item.rowType == 2 ? 'bold':'normal' }" v-for="(item, index) in items" :key="index">
        <td>{{item.saleId}}</td>
        <td class="date_time"><strong>{{item.create_at}} {{item.hour_at}}</strong></td>
        
        <td  :style="{color:item.soldBy == 'Retail' ? 'black':'red',fontWeight:item.soldBy == 'Retail' ? 'normal':'bold'}">{{item.soldBy}}</td>
        <td  :style="{color:item.soldBy == 'Retail' ? 'black':'red',fontWeight:item.soldBy == 'Retail' ? 'normal':'bold'}">{{item.customer}}</td>
        
        <td>
         
          <small v-if="item.rowType == 1" style="color:red" id="reso" class="form-text ">Reso da cliente</small>
          <small v-if="item.rowType == 0" style="color:black" id="vendita" class="form-text ">Vendita</small>
        </td>
         <td ><strong>{{item.assistant_code}} </strong></td>
        <td>{{item.barcode}}</td>
        <td>{{item.brand}} {{item.sku}} {{item.category}} </td>
        
        <td>{{item.color}}</td>
        <td>{{item.size}}</td>
        
        <!--<td class="text-right">{{item.qty}}</td>-->

        <td class="text-right">{{fmt1(item.price)}}</td>
        <td class="text-right">{{item.discount}}</td>
        <td :style="{color:item.rowType == 1 ? 'red':'black'}" class="text-right">{{fmt1(item.rowTotal)}}</td>
        
        <td :style="{color: item.rowType == 0 ? 'black':'brown'}" class="text-right">
          {{ item.total_rate_discount  }} %
         
        </td>
        <td  class="text-right">
          <span  :style="{color:'black'}" v-if="item.rowType == 0">
           {{fmt1(item.row_total_discount)}} 
           
          </span>
          <span v-else :style="{color:'blue'}" >
             {{ fmt1(item.totalDiscount)  }} 
         </span>
          
         
        
        </td>
        
        
        
        <td class="text-right">
         
          <span :style="{color:'black'}" v-if="item.rowType == 0">
            
            {{  fmt1(item.rowTotal - item.row_total_discount)  }}  
          
         </span>

         <span v-else :style="{color:'green'}" >
             {{ fmt1(item.rowTotal - item.totalDiscount)  }} 
         </span>
         

         
        </td>

        <td class="text-right">

           <i v-if="item.rowType==2 && item.round_total > 0 " style='color:red; font-size: 12px;'  class="mr-2" aria-hidden="true">
            <span>
            (+{{

               item.round_total

            }})
            </span>
          </i>
          
          <span style="color:black" v-if="item.rowType==2">
           <!-- {{fmt1(item.totalPaid)}}-->
            {{item.paymentType}}
          </span> 

          </td>
       <!-- <td :style="{fontSize:'16px'}" class="text-right">{{item.paymentType}}</td>-->
        <td > <i v-if="item.printTicket==1" class="fas fa-print" aria-hidden="true"></i></td>
        
      </tr> 
    </tbody>
        <tfoot>
        
      
      </tfoot> 
  </table>
  
  
  </div>

  <!-- COL -->
  </div>

  <!-- ROW -->
  </div>


<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<event-log  v-if="eventData.event_key" @close="eventData.event_key=0" v-bind:item_key="eventData.event_key" v-bind:item_type="eventData.event_type" ></event-log>
  </div>


</div>

<!--
<button  @click="eventLog()" class="btn btn-outline-primary btn-sm  mt-1 ml-1 mr-2">
  <i style="color:blue" class="	far fa-edit mr-3" aria-hidden="true"></i>
  NOTE   
</button>
-->




<div class="row">


<div class="dropdown">
  
  <button  class="btn btn-info btn-sm dropdown-toggle mt-1 mr-4 ml-4 " type="button" data-toggle="dropdown" aria-expanded="false">
    <i class="fas fa-ellipsis-v mr-2" aria-hidden="true"></i>
    NOTE
  </button>
  <div class="dropdown-menu ">

    <a  class="dropdown-item" @click="eventLog()" href="#">
      <i style="color:blue" class="	far fa-edit mr-3" aria-hidden="true"></i>                      
      MODIFICA
    </a>
                    
    <div class="dropdown-divider"></div>   
      <a class="dropdown-item" @click="printNotes()" href="#">
        <i   style="color:blueviolet" class="fas fa-print mr-2" aria-hidden="true"></i>
        STAMPA
        <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </a>
                                            
</div>
</div>

<span>
  <button  @click="printCustomerRetail()" class="btn btn-outline-primary  btn-sm mt-1 mr-2">
  <i style="color:red" class="far fa-sticky-note mr-3" aria-hidden="true"></i>
  RICEVUTA A4  
  <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>

  
</span>


<!--
<button  @click="createReceipt()" class="btn btn-outline-secondary btn-lg  mt-1 mr-3 ml-1">RICEVUTA 
  <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>
-->
<div v-if="btn">

<button  @click="printTicket1(1)"  class="btn btn-outline-primary  btn-sm  mt-1 mr-2">
  <i style="color:rgb(128, 0, 47)" class="fas fa-paperclip mr-3" aria-hidden="true"></i>
  RICEVUTA SOSPESO
</button>
<button  @click="printTicket1()"  class="btn btn-outline-primary  btn-sm mt-1 mr-2">
  <i style="color:green" class="fas fas fa-receipt mr-3" aria-hidden="true"></i>
  RICEVUTA DI CASSA
</button>
  <button   @click="printTicket2()"  class="btn btn-outline-primary btn-sm  mt-1 mr-2">
  <i style="color:blueviolet" class="fas fa-gift mr-3" aria-hidden="true"></i>
  TICKET CORTESIA 
  </button>
  <button   @click="printTicketCB()"  class="btn btn-outline-primary  btn-sm  mt-1 mr-2">
  <i style="color:brown" class="far fa-file-alt mr-3" aria-hidden="true"></i>
  RICEVUTA CASHBACK
  </button>

</div>

<div class="col">

  <button  v-if="rt" @click="printFiscalTicket()"  class="btn btn-outline-success fiscal_btn btn-lg float-right mt-1 mr-2 ml-1">
  <i  class="fas fa-print mr-3" aria-hidden="true"></i>
    STAMPA SCONTRINO FISCALE </button>
  <button v-if="rt"   @click="printGiftTicket()"  class="btn btn-outline-success fiscal_btn btn-lg float-right mt-1  mr-2">
  <i  class="fas fa-gift mr-3" aria-hidden="true"></i>
    STAMPA TICKET CORTESIA 
  </button>

</div>
</div>

 <!-- 
<button v-if="printer.length>0"  :disabled="printer_dev==null" @click="printTicketReceipt(printer_dev)"  class="btn btn-outline-secondary not_fiscal_btn   btn-lg float-right mt-1 mr-2">
  <i class="fas fas fa-receipt mr-3" aria-hidden="true"></i>
  TICKET PREVENDITA </button>
<button v-if="printer.length>0"  :disabled="printer_dev==null" @click="printTicketGift(printer_dev)"  class="btn btn-outline-secondary not_fiscal_btn btn-lg float-right mt-1 mr-2">
  <i class="fas fa-gift mr-3" aria-hidden="true"></i>
  TICKET CORTESIA </button>
-->


<!--
<div v-if="printer.length == 0 && !rt">
  <button  @click="printTicket1()"  class="btn btn-outline-secondary btn-lg float-right mt-1 mr-2">
  <i class="fas fas fa-receipt mr-3" aria-hidden="true"></i>
  TICKET PREVENDITA </button>
  <button   @click="printTicket2()"  class="btn btn-outline-secondary btn-lg float-right mt-1 mr-2">
  <i class="fas fa-gift mr-3" aria-hidden="true"></i>
  TICKET CORTESIA 
  </button>
</div>
-->


  





</div>



</template>
<script>


import eventLog                 from '@/components/common/EventLog.vue'
import alertBox                 from '@/components/common/AlertBox.vue'
import axios                    from 'axios'
import api                      from '@/api'
import JSPM                     from 'jsprintmanager'

import fiscalPrinter            from '@/components/rt/FiscalPrinter.vue'
import pdfCustomerReceipt       from '@/components/mixins/pdfCustomerReceipt.js'
import CustomerCortesia         from '@/components/mixins/CustomerCortesia.js'
import modalSpinner             from '@/components/common/ModalSpinner.vue'
import cancelBtn                from '@/components/common/CancelBtn.vue'
import printCCB                 from '@/components/mixins/CustomerCashBackHistory.js'
import fmt                      from '@/components/mixins/fmt.js'
import receiptHeading           from '@/components/mixins/ReceiptHeading.js'
import fiscalPrinterNew         from '@/components/rt/FiscalPrinterNew.vue'
import notFiscalEpsonReceipt    from '@/components/rt/EpsonModalNotFiscalReceipt.vue'
import printNotes               from '@/components/mixins/PrintNotes.js'

import { mapGetters }           from 'vuex';


export default {
  mixins: [pdfCustomerReceipt,CustomerCortesia,printCCB,fmt,receiptHeading,printNotes],
  props : ['storeId','deskId'], 
    
  components: {alertBox,eventLog,fiscalPrinter,modalSpinner,cancelBtn,fiscalPrinterNew,notFiscalEpsonReceipt},
  data() {
    return {
      btn                    : JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open,
      modalSpinner           : {spinner:false,show:false},     
      
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 

      items                  : [],
      spinner                : false,
      payments               : [],
          
      eventData              : {

        event_key            : 0,
        event_type           : ''
      },
      rt                     : {},
  
      saleId                 : 0,
      giftTicket             : false,
      
      customerId             : 0,
      receiptText            : [],
      
      fp                     : {
        show                 : false,
        notFiscal            : false

      },

      fiscalPrinterNew       : 
      {
        receiptSaleId     : 0,
        show              : false,
        fpId              : 0
        
      },
      notFiscal           : false

      
      
    };
  },
  computed :{
   
   ...mapGetters(['company']) ,  
   total : function() {
   
      var total = 0
      this.items.forEach(item => {
        if(item.rowType==2)
        {
          total += Number(item.row_total)
        }
      })
      return total
    }


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  async mounted() {
    
    
    this.receiptText = await this.getReceiptHeading(this.storeId,this.deskId)    
    this.getData()
    this.getStoreFiscalPrinter()
        
  },
  created() {
   
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
   
  },
  
  methods: {
   
    
    getFiscalPrinter1(Id)
    {
      

      if(Id == 0 || Id == 1 || Id == 6 || Id == 7)
      {
        return false
      }
      else
      {
        
        return true
      }
    },
    getFiscalPrinter2(Id)
    {
      if(Id == 1 || Id == 6 || Id == 7)
      {
        return true
      }
      else
      {
        return false
      }
    },
    setFiscalPrinter(component)
    {

        this.fiscalPrinterNew.component           = this.rt.type + component 
        this.fiscalPrinterNew.saleId              = this.saleId
       
        this.fiscalPrinterNew.url                 = this.rt.url
        this.fiscalPrinterNew.serialNumber        = this.rt.badge
        this.fiscalPrinterNew.fpId                = this.rt.fpId
        this.fiscalPrinterNew.show                = true
       
        console.log(this.fiscalPrinterNew)
    },
    closeFiscalPrinter()
    {
      this.fiscalPrinterNew.show          = false
      this.fiscalPrinterNew.receiptSaleId = 0
      this.fiscalPrinterNew.fpId          = 0
    },
    setAlertBox(title,msg,type)
    {
      this.msg.title = title
      this.msg.body = msg
      this.msg.type = type
    },

    
    async printTicketCB()
    {
         
      if(this.customerId>0)
      {
        const data = await this.getCBData(this.customerId)
        if(data[0].length>0)
        {
          this.printCashBackHistory(this.receiptText,data)
        }
      }
    
    },
    setModalSpinner(show)
    {
      
      this.modalSpinner.show = show
      
    },  
   printCustomerRetail()
  {

      this.pdfCustomerReceipt(this.saleId)

  },
    

  closeFiscalPrint()
  {
      this.giftTicket = false
      this.fp.notFiscal = false
      
      this.fp.show = false
      
  },  
  printFiscalTicket()
  {
    this.fp.notFiscal = false
    this.giftTicket = false    
    this.fp.show = true

    this.setFiscalPrinter('FiscalReceipt')
                
  },
  printNotFiscalTicket()
  {
    
    this.notFiscal = true
                
  },
  printGiftTicket()
  {
    
    this.giftTicket = true    
    this.fp.show    = true
    this.setFiscalPrinter('GiftReceipt')
    
    

  },
  getStoreFiscalPrinter()
  {
      const sp    = {'sp'      :'spStoreFiscalPrinter'}
      const data  = {'storeId' : this.storeId,'deskId' : this.deskId}
      const json  = Object.assign(data, sp);
      
      api.post(json).then(res => {
        if(res.status==200)
          {
            
            this.rt =  res.data.recordsets[0][0]    
           // console.log(this.rt)
  
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

  },

  
  eventLog()
  {
    if(this.items)
    {
      if(this.items.length>0)
      {
        this.eventData.event_key = this.items[0].saleId
        this.eventData.event_type = 'SALE'
      }

    }
  },  

  printNotes()
  {
    if(this.items)
    {
      if(this.items.length>0)
      {
        
        this.printNotesText(this.items[0].saleId)
      }

    }
  },

  
   /*
    createReceipt()
      {
        
        if(this.items.length==0)
        {
          return
        }    

        this.spinner = true
        this.msg     = ''
        var url      = process.env.VUE_APP_ROOT_API + "api/document/create/sale_receipt" 
        var data     = {}
        data.items   = this.items
        
        
        var json =  data

        
        axios({

        url     : url,
        method  : "post",
        data    : json,
        
      })
        .then(res => {
          this.pdf   =  process.env.VUE_APP_ROOT_API + 'api/pdf/' +  res.data                    
        })
        .catch(err => {})
        .finally(() => {
          this.spinner = false
           
        });
      },
     */

    formatList()
    {
        var arr = []        
        var total = 0               
        for (var i = 0; i < this.items.length; i++)   
          {
            var m = 1
            if(this.items[i]['rowType'] == 1)
            {
              m = -1
            }
            total += Number(this.items[i]['rowTotal']) * m
           
            arr.push(this.items[i])    
            if(this.items[i]['row_number'] == this.items[i]['row_count'])
              {
                
                arr.push({'rowType':2,'rowTotal':total,'totalDiscount' : this.items[i]['totalDiscount'] ,'totalPaid':this.items[i]['totalPaid'],'printTicket':this.items[i]['printTicket'],
                'paymentType' : this.items[i]['paymentType'],'round_total':this.items[i]['round_total'],'total_rate_discount':this.items[i]['total_rate_discount']
                
                })
                total = 0
                                
              }
           
            
          }

         
          arr.forEach(item=>{

            if(item.rowType != 2)
            {
              //item.totalDiscount = 0
              item.totalPaid     = 0
              item.printTicket   = 0
              item.paymentType   = ''
              // Scarto 1° riga Scontrino per Data e Ora
              if(item.row_number > 1 )
              {
                item.create_at = ''
                item.hour_at = ''
              }
              
            }
          })
          this.items = arr

          
    },
    

    getData() 
    {
      
      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true
      this.modalSpinner.title   = 'Ricerca in corso ...'
      
      const sp    = {'sp'      : 'spStoreLastSale'} 
      const data  = {'storeId' : this.storeId,'deskId':this.deskId}
      const json  = Object.assign(data, sp)
      const promise  = api.promise(json) 

      promise.then((res) => {
            this.modalSpinner.show    = false
            if(res.data.recordsets[0].length > 0 )
            {
              this.customerId = res.data.recordsets[0][0].customerId 
              this.saleId = res.data.recordsets[0][0].saleId 
              this.items = res.data.recordsets[0]
                                          
            }
            this.payments = res.data.recordsets[1]
            if(this.items.length>0)
            {                 
               this.formatList()
            }
          
              

        }).catch((err) => {

              const msg = err.data ? err.data : err
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = msg

        }).finally(() => {
              
            // clean up the resources
        });
       
      },      

  // ESC/POS RICEVUTA 
  printTicket1(printCustomer)
  {
    
     function jspmWSStatus() {
        if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
            return true;
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
            alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
            return false;
        }
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
            alert('JSPM has blocked this website!');
            return false;
        }
    }

    if(this.items.length==0)
    {
      return
    }    

    

    var pad = ' '  
    const GS = '\x1d'  
    const esc = '\x1B'; //ESC byte in hex notation
    const newLine = '\x0A'; //LF byte in hex notation

    var cmds = esc + "@"; //Initializes the printer (ESC @)
    var cols = 48
    
    //cmds += newLine  
    
    // HEADER 
    this.receiptText.forEach(row =>{
      if(row.type == 'H')
      {
        if(row.order_by == 1)
        {   
            cols = row.cols   
                      
            cmds += esc + 'a' + '\x01'
            cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
            cmds += row.text  //text to print
            cmds += newLine;
            
        }
        else
        {
            cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            cmds += row.text  //text to print
            cmds += newLine;
        }
        
      }

    })
        
    if(printCustomer && this.items[0].customer)
    {
      cmds += newLine
      cmds += this.items[0].customer
    }  
    
    cmds += newLine

    let spc = cols - 15
    
    cmds += GS + '!' +  '\x01' //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
    cmds += 'DESCRIZIONE' + pad.repeat(spc) + 'EURO'   //text to print
        
    cmds += newLine
        
    var data = ''
    var saleId = ''
    var total = 0
    var subtotal = 0
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    
    // BODY
    this.items.forEach(item => {
        

        if(item.rowType == 0 || item.rowType == 1)
        {
          const m = item.rowType == 0 ? 1 : -1
          var price = this.fmt1(item.rowTotal * m)
          var product = (item.barcode + ' '  + item.category + pad.repeat(25)).substring(0,29) + ' '

          total = total + Number(item.rowTotal*m)
          spc = cols - product.length - price.length
          
          cmds += product + pad.repeat(spc) +  price   //text to print
          //cmds += product + pad.repeat(18 - price.length) +  price   //text to print

          cmds += newLine;

          if(data.length==0)
          {

            data = item.create_at + ' ' + item.hour_at
            
            saleId = item.saleId
          }
          
        }
        subtotal = item.totalDiscount
    })

    cmds += newLine;
   
    total = total - subtotal
    if(subtotal > 0)
    {
      subtotal = this.fmt1(subtotal)      
      spc = cols - 9 -  subtotal.length
      cmds += 'SCONTO' + ' ' + pad.repeat(spc) + '- ' + subtotal   //text to print
      cmds += newLine;      
    }
    
    total = this.fmt1(total)
    cmds += GS + '!' +  '\x01'
    spc = cols - 12 - total.length
    cmds += 'TOTALE EURO ' + pad.repeat(spc) +  total   //text to print
    cmds += newLine
    cmds += newLine
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)

    var total1 = '0,00'
    var total2 = '0,00'  
    var total3 = '0,00'
    var total4 = '0,00'

    // CASH
    var payment = this.payments.filter(row => row.typeId == 'CASH')
    if(payment.length>0)
    {
     total1 = this.fmt1(payment[0].amount)
     
    }
    
    // ELEC PAGO LIGHT SCALA PAY
    payment = this.payments.filter(row => row.typeId == 'ELEC' || row.typeId == 'PAGO' || row.typeId == 'SCAL' || row.typeId == 'KLAR' )
    let total_payment = 0
    if(payment.length>0)
    {
      payment.forEach(payment=>{
        total_payment += payment.amount
      })
      total2 = this.fmt1(total_payment)
      
    }
    
    // NOT PAID
    payment = this.payments.filter(row => row.typeId == 'CRED')
    if(payment.length>0)
    {
      total3 = this.fmt1(payment[0].amount)
    }

    // COUPON
    payment = this.payments.filter(row => row.typeId == 'COUP')
    if(payment.length>0)
    {
      total4 = this.fmt1(payment[0].amount)
    }

    spc = cols - 18 - total1.length
    cmds += 'PAGAMENTO CONTANTE' + pad.repeat(spc) +  total1   //text to print
    cmds += newLine
    spc = cols - 21 - total2.length
    cmds += 'PAGAMENTO ELETTRONICO' +  pad.repeat(spc) + total2   //text to print
    cmds += newLine
    spc = cols - 16 - total4.length
    cmds += 'PAGAMENTO COUPON' +  pad.repeat(spc) + total4   //text to print
    cmds += newLine
    spc = cols - 12 - total3.length
    cmds += 'NON RISCOSSO' + pad.repeat(spc) +  total3   //text to print
    cmds += newLine
    cmds += newLine
    
    var tot_items = this.items.length-1
    spc = cols - 15 - tot_items.toString().length
    cmds += 'TOTALE ARTICOLI' + pad.repeat(spc) +  tot_items   //text to print
    cmds += newLine
    cmds += newLine
    cmds += data    //text to print
    cmds += newLine

    

    cmds += newLine


    // BARCODE  
    cmds += esc + 'a' + '\x01'
    cmds += GS  + 'h' + '\x50'
    cmds += GS  + 'H' + '\x02'
    cmds += GS  + 'f' + '\x01'
    cmds += GS  + 'k' + '\x04' + 'S' +  saleId + '\x00'

    
    cmds += newLine
    cmds += newLine
    cmds += newLine
    
  
    // FOOTER
    this.receiptText.forEach(row=>{

      if(row.type=='F')
      {        
        if(row.text == 'Come riconoscimento del debito')
        {  
          if(total3 != '0,00') 
          {
            cmds += row.text
            cmds += newLine  
          }
          
        }
        else
        {
          
          cmds += row.text   //text to print
          cmds += newLine
        }

      }
    })
    
    
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine
    
    cmds += newLine
    
    cmds += GS + 'V' + '\x01'   
    cmds += newLine
    
  
    if (jspmWSStatus()) {
            //Create a ClientPrintJob
            var cpj = new JSPM.ClientPrintJob();
            cpj.clientPrinter = new JSPM.DefaultPrinter();
            
            /*
            //Set Printer type (Refer to the help, there many of them!)
            if ($('#useDefaultPrinter').prop('checked')) {
                cpj.clientPrinter = new JSPM.DefaultPrinter();
            } else {
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
            }
            */
           

            cpj.printerCommands = cmds;
            //Send print job to printer!
            cpj.sendToClient();
            

     }




  },
  


  printNotFiscal()
  {
      if(this.items.length==0)
      {
        return
      }
      let saleId = this.items[0].saleId
      data     = {'saleId':saleId}
      axios({
      url    : 'http://127.0.0.1:8000/notFiscal',
      method : 'post',
      data   : data
      })

  },



  // ESC/POS CORTESIA
  printTicket2()
  {
    if(this.items.length==0)
    {
      return
    }
    const sale = {saleId : this.saleId,'create_at' : this.items[0].create_at ,'hour_at' : this.items[0].hour_at }
    this.printTicketCortesia(this.receiptText,sale)
        
  },


  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position  : relative;
height    : 600px;
overflow  : auto;
}
.pointer:hover
{
  background-color   : blue;
  color              : white;
  _cursor             : pointer;
}
.table-wrapper-scroll-y {
  display: block;
}


thead tr:nth-child(1) th {
  font-family : "Roboto Condensed";
  font-size   : 16px;
  
  background  :  hwb(45 4% 9%); 
  color       : black;

  position    : sticky;
  top         : 0;
  z-index     : 10;
}


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.date_time
{
  font-size: 18px;
}

table th:first-child
{
  border-radius : 0 0 0 8px;
}
table th:last-child
{
  border-radius : 0 8px 0 0;  
}

.btn-lg{
  _color : #FF6C15;
  _border-color: #FF6C15!important
}
.btn-lg:hover {

    background-color: navy !important;
    color : white
}

.fiscal_btn:hover {
    
    background-color: forestgreen !important;
}
.not_fiscal_btn:hover {
    cursor             : pointer;
    _background-color: forestgreen !important;
}
.table1
{
  background-color: hwb(45 4% 9%); 
  color: black;
}
.table tfoot  tr:nth-child(1) th
 {

   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;
    border-color : green ;
    border-width : 5px;

 } 
.main
{
  height:45px;
} 
</style>